import React from 'react'
import axios from 'axios';

// import * as C from './creators'
// import * as T from './tools'
// import GetDimensions from './GetDimensions'
// import GetVideo from '../partials/GetVideo'
// import GetImage from '../partials/GetImage'
// import GetIframe from '../partials/GetImage'

class ElementLoader extends React.Component {

	_isMounted = false
  _isLoading = false
  _isFakeLoaded = false
  _didUpdate = false
  _vimeoError = false

	constructor( props ) {
		super( props )
		this.state = {
			init: this.props.count === this.props.element.index,
			preloader: this.props.count === this.props.element.index,
			progress: false,
			value: 0,
			loaded: false,
      error: false,
			loopVideo: null,
			element: this.props.element
    }
    this.videoRef = React.createRef()
	}

	componentDidMount() {
    this._isMounted = true
    
		// const e = this.state.element
		// if ( e.type === "vimeo" ) {
		// 	// if ( !e.width || !e.height ) {
    //     e.dimensions = this.fetchVimeoData( e )
    //     this.setState( {
    //       element: e
    //     } )
		// 	// }
		// }
  }
	componentWillUnmount() {
		this._isMounted = false
	}
	componentDidUpdate() {
    this._didUpdate = true
  }
  getDimensions( flag, element ) {

    // flag from element?
    let dimensions = {}
  
    // window		
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight

    // TODO: make values dynamic
    // css values
    // vars
    const unit = 20
    const pageFrame = windowWidth > 1111 ? unit * 5 : unit
    const contentWidth = windowWidth - pageFrame * 2
    const maxHeight = windowHeight * 0.8
  
    // element
    // element from state?
    // const element = props.state.element
    let originalWidth = element ? element.width : null
    let originalHeight = element ? element.height : null
    let ratio = originalWidth / originalHeight
    let width = originalWidth
    let height = originalHeight
  
    if ( flag === "teaser" ) {
  
      // TEASER
      const citizenWidth = 400
      const rebelWidth = citizenWidth * 1.5
      let isRebel = originalWidth === rebelWidth && originalWidth > originalHeight
  
      // correct original if width is incorrect
      const correctWidth = originalWidth === citizenWidth || originalWidth === rebelWidth
      if ( !correctWidth ) {
        originalWidth = isRebel ? rebelWidth : citizenWidth
        originalHeight = originalWidth / ratio
      }
  
      // set itemWidth
      let item = 328    
      if ( windowWidth > 1365 ) {
        item = citizenWidth
      } else if ( windowWidth < 834 ) {
        item = 320 - pageFrame * 2
        if ( windowWidth < item * 1.5 + pageFrame * 2 ) isRebel = false
      }
      const itemWidth = isRebel ? item * 1.5 : item
      width = itemWidth
      height = width / ratio
    } else if ( flag === "showcase" && element.type === "vimeo" ) {
      const vimeoDimensions = this.fetchVimeoDimensions( element )
      width = vimeoDimensions.width || contentWidth
      height = vimeoDimensions.height
      ratio = width / height
      if ( !height ) {
        ratio = 16 / 9
        height = width / ratio
      }
    }
      
    // handle ratio
    if ( width > contentWidth ) {
      width = contentWidth
      height = width / ratio
    }
    if ( height > maxHeight ) {
      height = maxHeight
      width = height * ratio
    }
    // return dimensions object
    dimensions = {
      width: Math.round( width ),
      height: Math.round( height )
    }
    return dimensions    
  }
  
	async fetchVimeoDimensions( element ) {
    if ( !this._vimeoError ) {
      const e = element
      const vimeoApi = `//vimeo.com/api/v2/video/${ e.id }.json`
      await axios
        .get( vimeoApi )
        .then( ( res ) => {
          const data = res.data[ 0 ]
          e.width = data.width
          e.height = data.height
          return e
        } )
        .catch( error => { 
          this._vimeoError = true
          console.log( error ) 
        } )
    }
	}

	handleDidLoad( i ) {
    this._isLoading = false
    if ( this._isMounted && this._didUpdate ) {
      this.setState( {
        init: false,
        preloader: false,
        loaded: true
      } )
    }
		if ( i ) return i
  }
  
	handleSrc( element ) {
    const e = element
    e._isLoading = this._isLoading
		e.loading = i => this._isLoading = i
		e.didLoad = ( i ) => this.handleDidLoad( i )
    e.oneUp = this.props.oneUp

    switch ( e.type ) {
			case "image":
				this.createImage( e )
				break
			case "video":
				this.createVideo( e )
				break
			case "vimeo":
				this.createIframe( e )
				break
			default:
        return
		}
	}



  createImage(props) {
    const img = new Image();
    img.onload = () => props.didLoad( props.oneUp( props.index ) );
    img.src = props.src;
    return props.loading(true);
  }
  createIframe(props) {
    const iframe = document.createElement('iframe'); 
    iframe.src = props.src;
    this._isLoading = true;
    if (iframe.src) return props.didLoad(props.src, props.oneUp(props.index));
  }
  createVideo( props ) {
    if ( !this._isLoading ) {
      const video = document.createElement('video');

      let timer
      const startFeedbackGenerator = () => {
        timer = setTimeout( () => {
          return props.didLoad(props.src, props.oneUp(props.index));
        }, 1000 )
      }
      const stopFeedbackGenerator = () => clearTimeout( timer )
      
      startFeedbackGenerator()

      video.onloadstart = () => {
        stopFeedbackGenerator()
        return props.didLoad(props.src, props.oneUp(props.index));
      }
      video.onprogress = () => {
        video.src = props.src;
        this._isLoading = true
        this._isFakeLoaded = true
      }
    }
  }

	render() {
		// TODO: refactor vimeo / iframe shizzl
		const loading = this._isLoading
		const loaded = this.state.loaded

    const preloaderSrc = this.props.preloaderSrc
		const tailSpin = { background: `url( ${ preloaderSrc } ) no-repeat center center` }
    
		const element = this.state.element
		const init = this.props.count === element.index
		const showPreloader = !loaded && ( init || loading )
		const flag = this.props.flag
    const dimensions = this.getDimensions( flag, element )
		const divStyle = {
      width: dimensions.width || null,
			height: dimensions.height || null
    }
    element.loading = ( i ) => { this._isLoading = i }
    element.didLoad = ( i ) => this.handleDidLoad( i )
    element.onClick = this.props.onClick
    const divId = this.props.divId || ""
		const className = this.props.className
		const preloaderBackground = !loaded ? " preloader-background" : ""
    const divClassName = className + " " + preloaderBackground
    
    const imgTag = ( e ) => (
      <figure className = "appear">
        <img
          id = { e.id }
          src = { e.src }
          title = { e.title }
          alt = { e.title }
        />
      </figure>
    )
		const iframeTag = ( e ) => (
			<div style = { divStyle }>
				<iframe
          ref = { this.iframeRef }
					className = "appear" 
					key = { e.src.split( '/' )[ e.src.split( '/' ).length - 1 ] }
					src = { e.src }
					id = { e.id }
					title = { e.title }
					frameBorder = "0"
					webkitallowfullscreen = "true"
					mozallowfullscreen = "true"
					allowFullScreen
				>
				</iframe>
			</div>
    )
    const videoTag = ( init, e ) => (
			<figure
        className = { init ? "appear" : "" }
			>
				<video
          ref = { this.videoRef }
					id = { e.id }
					src = { init ? e.src : null }
					aria-hidden = "true"
					autoPlay
					loop
					muted
					playsInline
					poster = { e.poster }
					tabIndex = "-1"
				/>
			</figure>
		)

		const preloaderTag = (
			<div
				className = "appear preloader"
				style = { tailSpin }
			/>
    )
		if ( init && !loading && !loaded ) { this.handleSrc( element ) }

		const getTag = ( element ) => {
      const e = element
      let tag
      switch ( e.type ) {
        case "image":
          if ( loaded ) tag = imgTag( e )
          break
        case "vimeo":
          tag = iframeTag( e )
          break
        case "video":
          tag = videoTag( init, e )
          break
        default:
          throw new Error()
      }
      return tag
    }

    const contentTag = getTag( element )

    return (
			<div 
				className = { divClassName } 
				style = { divStyle }
				id = { divId }
				onClick = { element.onClick }
			>
				{ contentTag }
				{ showPreloader && preloaderTag }
			</div>
		)

	}

}

export default ElementLoader
